import React from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

const PILL_TEXT = '#ffffff'
const PASS_BG = '#a3a242'
const FAIL_BG = '#d7383c'
const UNKNOWN_BG = '#7e8299'
const PASS_TEXT = '#a3a242'
const FAIL_TEXT = '#d7383c'

type Props = {
  status?: string | null
  /** When set with language/id, hover shows QC checklist (Name / Lang / ID). */
  nameMentioned?: boolean | null
  languageMentioned?: boolean | null
  idMentioned?: boolean | null
}

const ChecklistItem: React.FC<{label: string; mentioned: boolean}> = ({label, mentioned}) => (
  <span className='d-inline-flex align-items-center me-2 fs-8 text-nowrap'>
    <i
      className={`bi ${mentioned ? 'bi-check-circle' : 'bi-x-circle'} me-1`}
      style={{color: mentioned ? PASS_TEXT : FAIL_TEXT}}
    ></i>
    {label}: {mentioned ? 'mentioned' : 'missed'}
  </span>
)

const AiQcStatusBadge: React.FC<Props> = ({
  status,
  nameMentioned,
  languageMentioned,
  idMentioned,
}) => {
  if (!status) return null

  let badge: React.ReactNode
  if (status === 'Pass') {
    badge = (
      <span
        className='badge fw-semibold text-center'
        style={{backgroundColor: PASS_BG, color: PILL_TEXT, padding: '6px 12px', borderRadius: 20}}
      >
        Pass
      </span>
    )
  } else if (status === 'Fail') {
    badge = (
      <span
        className='badge fw-semibold text-center'
        style={{backgroundColor: FAIL_BG, color: PILL_TEXT, padding: '6px 12px', borderRadius: 20}}
      >
        Fail
      </span>
    )
  } else {
    badge = (
      <span
        className='badge fw-semibold text-center'
        style={{backgroundColor: UNKNOWN_BG, color: PILL_TEXT, padding: '6px 12px', borderRadius: 20}}
      >
        Unknown
      </span>
    )
  }

  const hasChecklist =
    typeof nameMentioned === 'boolean' &&
    typeof languageMentioned === 'boolean' &&
    typeof idMentioned === 'boolean'

  if (!hasChecklist) return badge

  return (
    <OverlayTrigger
      placement='top'
      overlay={
        <Tooltip 
          id='ai-qc-checklist-tooltip' 
          className='ai-qc-checklist-tooltip'
          style={{ '--bs-tooltip-max-width': 'none' } as React.CSSProperties}
        >
          <div className='d-flex flex-nowrap align-items-center py-1 px-1'>
            <ChecklistItem label='Name' mentioned={nameMentioned!} />
            <ChecklistItem label='Lang' mentioned={languageMentioned!} />
            <ChecklistItem label='ID' mentioned={idMentioned!} />
          </div>
        </Tooltip>
      }
    >
      <span className='d-inline-block' style={{cursor: 'default'}}>
        {badge}
      </span>
    </OverlayTrigger>
  )
}

export default AiQcStatusBadge
